// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf, tupleOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isTimeSeries = arrayOf(tupleOf(number, number));

export const isAppsAppGroupIdChartsSessionsResult = objectOf({
  lifetime_users: number,
  lifetime_users_by_app: recordOf({
    key: string,
    value: number,
  }),
  lifetime_sessions: number,
  lifetime_sessions_by_app: recordOf({
    key: string,
    value: number,
  }),
  current_mau: number,
  first_event_date: number,
  daily_sessions: isTimeSeries,
  hourly_sessions: isTimeSeries,
  daily_sessions_by_segment: recordOf({
    key: string,
    value: isTimeSeries,
  }),
  daily_sessions_by_app_version: recordOf({
    key: string,
    value: isTimeSeries,
  }),
  daily_engagement_times: arrayOf(
    objectOf({
      type: string,
      title: string,
      time: number,
    })
  ),
  hourly_engagement_times: arrayOf(
    objectOf({
      type: string,
      title: string,
      time: number,
    })
  ),
  daily_mau: isTimeSeries,
  daily_dau: isTimeSeries,
  daily_dau_by_segment: recordOf({
    key: string,
    value: isTimeSeries,
  }),
  daily_new_users: isTimeSeries,
  daily_new_users_by_segment: recordOf({
    key: string,
    value: isTimeSeries,
  }),
});
